import { MetadataProvider, ModalProvider, ThemeProvider, TooltipProvider } from "@qw/ui";
import { NuqsAdapter } from "nuqs/adapters/react-router/v7";
import { RouterProvider } from "react-router";
import "./app.css";
import { QwibTelemetryProvider } from "./qwib-telemetry-provider";
import { router } from "./router";

export const App = () => (
  <QwibTelemetryProvider>
    <MetadataProvider initialMetadata={{ title: "QWIB" }}>
      <ThemeProvider>
        <ModalProvider>
          <TooltipProvider>
            <NuqsAdapter>
              <RouterProvider router={router} />
            </NuqsAdapter>
          </TooltipProvider>
        </ModalProvider>
      </ThemeProvider>
    </MetadataProvider>
  </QwibTelemetryProvider>
);
